module.exports = __webpack_public_path__ + "static/media/FDA_loadBar.9a1585c0.webp";